// Meta Pixel (client-side) — single Foundation-wide Dataset, init once, no duplicate PageViews.
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;

export function initMetaPixel() {
  if (!PIXEL_ID || typeof window === "undefined" || window.fbq) return;
  const f = function () {
    f.callMethod ? f.callMethod.apply(f, arguments) : f.queue.push(arguments);
  };
  window.fbq = f;
  if (!window._fbq) window._fbq = f;
  f.push = f;
  f.loaded = true;
  f.version = "2.0";
  f.queue = [];
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  window.fbq("init", PIXEL_ID);
}

let lastTrackedPath = null;

// Fires PageView once per real route change (skips duplicate mounts/re-renders on the same path).
export function trackPageView(pathname) {
  if (!PIXEL_ID || !window.fbq || pathname === lastTrackedPath) return;
  lastTrackedPath = pathname;
  window.fbq("track", "PageView");
}

// Meta standard events (PageView, ViewContent, Lead, CompleteRegistration, InitiateCheckout, Purchase...)
export function trackMetaEvent(eventName, params = {}, eventId) {
  if (!PIXEL_ID || !window.fbq) return;
  if (eventId) window.fbq("track", eventName, params, { eventID: eventId });
  else window.fbq("track", eventName, params);
}

// Foundation-specific custom events (ApplicationStarted, ApplicationSubmitted, PaymentInitiated)
export function trackMetaCustomEvent(eventName, params = {}, eventId) {
  if (!PIXEL_ID || !window.fbq) return;
  if (eventId) window.fbq("trackCustom", eventName, params, { eventID: eventId });
  else window.fbq("trackCustom", eventName, params);
}

function readCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : "";
}

// Reads Meta's own first-party click/browser-id cookies (set by the Pixel script itself) so the
// backend can attach them to the server-side CAPI Purchase event for stronger attribution/match quality.
export function getMetaCookies() {
  return { fbp: readCookie("_fbp") || undefined, fbc: readCookie("_fbc") || undefined };
}
